import imgPlaceHolder from "../../../../static_assets/img-placeholder.svg";

export const CropFamilyDefaultDataset = {
  langMap: [{ langCode: "en", name: "", description: "" }],
  rotationAfter: [],
  rotationsBeforeRepeat: "3",
  image: imgPlaceHolder,
};

// export const addCropFamLang = {
//   langMap: [{ name: "", description: "" }],
//   rotationAfter: [],
//   rotationsBeforeRepeat: "3",
//   image: imgPlaceHolder,
// };

export const newlangTemplate = {
  langMap: { name: "", description: "" },
  rotationAfter: [],
  rotationsBeforeRepeat: "3",
  image: imgPlaceHolder,
};
